<template>
  <div class="canvassListPage"
   @touchstart="touchEvent" 
    @touchmove="touchEvent" 
    @touchend="touchEvent" 
    @scroll="touchEvent">
    <XR-head titleText="招商加盟" :rightShow="false"></XR-head>    

    <img src="/static/help/helper-banner.gif" class="banner" />
    <div class="topic-title">诚邀加盟&nbsp;&nbsp;共赢天下</div>

    <mu-list v-if="!loaded" v-for="aItem in articleList" :key="aItem.Id">
      <router-link :to="'/canvassDetail?id='+aItem.Id">
        <mu-list-item :title="aItem.ArticleTitle" :describeText="aItem.UpdateDateName"></mu-list-item>
      </router-link>      
    </mu-list> 
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data(){
    return {      
      dialog: false,
      loaded: true,
      articleList:[],
      queryInfo:{
        pageIndex:1,
        pageSize:20
      }
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getCanvassList()
  },
  methods:{
    touchEvent (){
        var scrollTop = this.$el.scrollTop
        var imgHeigth= 300+65 
        var opacityValue=this.$el.scrollTop/imgHeigth
        document.querySelector('.mu-appbar').style.background='rgba('+this.themeColor+','+opacityValue+')'
    }, 
    getCanvassList(){
      var ths = this;   
      ths.$post(
        "/Shop/ArticleServer/GetHealthyAricleList",
        JSON.stringify(this.queryInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.loaded=false   
          ths.articleList = res.Data
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
}
</script>

<style>
.canvassListPage{
  background: white;
  overflow-x: hidden;
  overflow-y: scroll;
}
.canvassListPage .XR-head{
    position: fixed;
    background: rgb(0,0,0,0);
    box-shadow: none;
  }
.canvassListPage .XR-head .left .mu-icon-button .fa-angle-left {
  background: rgba(71,74,79,0.25);
  border-radius: 50%;
}
.canvassListPage .XR-head .mu-appbar-title span {
  background: rgba(71,74,79,0.25);
  padding: 3px 6px;
  color: #fff;
}
.canvassListPage .banner{
  width:100%;
  display: block;
}
.canvassListPage .topic-title{
  background-color: #eee;
  text-align: center;
  line-height: 50px;
  height: 50px;
  overflow:hidden;
  font-size: 14px;
  margin-bottom: 16px;
}
.canvassListPage .mu-item-wrapper .mu-item-title{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/canvassList.vue